var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 340,
    viewBox: "0 0 176 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.165 43.7628H117.911V124.257H184.165C216.288 124.257 235.026 104.689 235.026 84.0031C235.026 63.3309 216.288 43.7628 184.165 43.7628ZM189.519 212.02H117.911V354H0.796875V-43.9998H189.519C295.256 -43.9998 352.14 18.6039 352.14 84.0031C352.14 149.416 295.256 212.02 189.519 212.02Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterP);
export default __webpack_public_path__ + "static/media/footer-p.dbac899433cfd390b59d54e831bded10.svg";
export { ForwardRef as ReactComponent };